import React from 'react';
import {SafeAreaView, StyleSheet, Text, View} from 'react-native';
import {COLORS} from '../../theme/themeTokens';
import SecureLockIcon from '../../components/icons/SecureLockIcon';

interface LoginLockoutScreenProps {
  remainingSeconds: number;
}

/**
 * The screen used to follow the attempt count with a line about the personal
 * manager, different in each of the four notification states — being sent,
 * sent, failed to send, not yet tried. Locked out of their own account,
 * a client was being told how our errand to their manager was going: worst
 * of all on a failure, "we couldn't notify your personal manager, please
 * contact them directly", which hands them our problem.
 *
 * The screen says the one thing that concerns them now. The manager is still
 * notified — that goes on in the background, and loginLockout keeps the
 * status so the reporter does not send twice.
 */
export const LoginLockoutScreen: React.FC<LoginLockoutScreenProps> = ({
  remainingSeconds,
}) => (
  <SafeAreaView style={styles.container}>
    <View style={styles.content}>
      <View style={styles.icon}>
        <SecureLockIcon />
      </View>
      <Text style={styles.subtitle} accessibilityLiveRegion="polite">
        We blocked app for {remainingSeconds} sec
      </Text>
      <Text style={styles.errorText} accessibilityLiveRegion="polite">
        Incorrect password. You have 0 attempts remaining.
      </Text>
    </View>
  </SafeAreaView>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: COLORS.white,
  },
  content: {
    flex: 1,
    alignItems: 'center',
    paddingHorizontal: 32,
    paddingTop: 112,
  },
  icon: {
    width: 63,
    height: 73,
    marginBottom: 44,
  },
  subtitle: {
    fontFamily: 'Inter',
    fontSize: 14,
    color: COLORS.deepNavy,
    textAlign: 'center',
    marginBottom: 12,
  },
  errorText: {
    width: 344,
    maxWidth: '100%',
    fontFamily: 'Inter',
    fontSize: 14,
    lineHeight: 20,
    fontWeight: '400',
    letterSpacing: 0,
    color: '#CD0A0A',
    textAlign: 'center',
  },
});

export default LoginLockoutScreen;
